import type { ParsedResume } from './types'

// Static Indonesian sample of a cleanly-parsed CV. Rendered server-side on the
// cek-cv-ats page so the OpenResume-style parse table ships as indexable HTML.
export const SAMPLE_PARSED_RESUME: ParsedResume = {
  profile: {
    name: 'Budi Santoso',
    email: 'budi.santoso@email.com',
    phone: '+62 812 3456 7890',
    location: 'Jakarta, Indonesia',
    link: 'linkedin.com/in/budi-santoso',
    summary:
      'Fresh graduate Manajemen yang fokus di digital marketing dan analisis data. Mencari peran marketing entry-level.',
  },
  educations: [
    {
      school: 'Universitas Contoh Indonesia',
      degree: 'S1 Manajemen',
      gpa: 'IPK: 3.65',
      date: 'Aug 2021 - Mei 2025',
      descriptions: ['Konsentrasi Pemasaran, skripsi tentang perilaku konsumen e-commerce'],
    },
  ],
  workExperiences: [
    {
      company: 'PT Contoh Sejahtera',
      jobTitle: 'Marketing Intern',
      date: 'Jan 2025 - Jun 2025',
      descriptions: [
        'Kelola 4 akun media sosial, naikkan engagement 38% dalam 6 bulan',
        'Susun laporan performa mingguan pakai Google Analytics',
      ],
    },
    {
      company: 'Himpunan Mahasiswa Manajemen',
      jobTitle: 'Ketua Divisi Acara',
      date: '2023 - 2024',
      descriptions: ['Koordinasi tim 12 orang untuk seminar dengan 300+ peserta'],
    },
  ],
  skills: ['Digital Marketing', 'Google Analytics', 'SQL', 'Copywriting', 'Meta Ads'],
}
